import { render, staticRenderFns } from "./GlobalTable.vue?vue&type=template&id=f647a1f2&scoped=true"
import script from "./GlobalTable.vue?vue&type=script&lang=js"
export * from "./GlobalTable.vue?vue&type=script&lang=js"
import style0 from "./GlobalTable.vue?vue&type=style&index=0&id=f647a1f2&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"
import style1 from "./GlobalTable.vue?vue&type=style&index=1&id=f647a1f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f647a1f2",
  null
  
)

export default component.exports